"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/**
 * Remove undefined props from object
 */
function clean(obj) {
    return Object.entries(obj).reduce((acc, [key, val]) => {
        return val ? Object.assign(Object.assign({}, acc), { [key]: val }) : acc;
    }, {});
}
const datePattern = /^\d{8}(T\d{6}Z?)?$/;
/**
 * Generate a Google Calendar event URL
 */
function googleCalendarEventUrl(args) {
    const { start, end, title } = args, rest = tslib_1.__rest(args, ["start", "end", "title"]);
    if (start && !end) {
        throw new Error('`end` is required when `start` is provided');
    }
    if (!start && end) {
        throw new Error('`start` is required when `end` is provided');
    }
    if (start && !datePattern.test(start)) {
        throw new Error('`start` is malformed');
    }
    if (end && !datePattern.test(end)) {
        throw new Error('`end` is malformed');
    }
    if (start && end && start.length !== end.length) {
        throw new Error('`start` and `end` should be of the same format`');
    }
    const searchParams = Object.assign({ action: 'TEMPLATE', dates: start && end ? `${start}/${end}` : undefined, text: title }, rest);
    const urlSearchParams = new URLSearchParams(clean(searchParams));
    return ('https://calendar.google.com/calendar/event?' + urlSearchParams.toString());
}
exports.googleCalendarEventUrl = googleCalendarEventUrl;
//# sourceMappingURL=index.js.map